import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { getCookie } from '@App/helpers/cookies'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import PublicSearchPopup from '@Components/Popups/PublicSearchPopup'
import { PUBLIC_SEARCH_COOKIE } from '@Const/cookies'
import PublicSearchByWorkTab from '@Scenes/PublicSearchScene/PublicSearchByWorkTab'
import PublicSearchByWriterTab from '@Scenes/PublicSearchScene/PublicSearchByWriterTab'
import PublicSearchByPublisherTab from '@Scenes/PublicSearchScene/PublicSearchByPublisherTab'
import { StoresContext } from '@App/contexts'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const PublicSearchScene = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(!getCookie(PUBLIC_SEARCH_COOKIE))
    const { uiStore } = useContext(StoresContext)

    useEffect(() => {
        uiStore.setOnLoginPage(false)
        analyticsSendPage('public_search')
    }, [])

    const publicSearchTabs: Tab[] = [
        {
            tabName: 'Work',
            tabDisplayName: 'Work',
            tabComponent: <PublicSearchByWorkTab key="Work" />,
        },
        {
            tabName: 'Writer',
            tabDisplayName: 'Writer',
            tabComponent: <PublicSearchByWriterTab key="Writer" />,
        },
        {
            tabName: 'Publisher',
            tabDisplayName: 'Publisher',
            tabComponent: <PublicSearchByPublisherTab key="Publisher" />,
        },
    ]

    return (
        <>
            <title>Public Search</title>
            <main className="public-search-scene">
                <div className="global-container">
                    <div className="search-header">
                        <h1>The MLC Public Work Search</h1>
                    </div>

                    <p className="starting-paragraph">
                        The accuracy and completeness of The MLC&apos;s data is determined solely by our Members.
                    </p>
                    <p className="ending-paragraph">It is not an authoritative source for recording information.</p>
                    <p>
                        Please{' '}
                        <a
                            href="https://themlc.com/faqs/categories/music-industry-terminology"
                            target="_blank"
                            rel="noreferrer"
                        >
                            click here
                        </a>{' '}
                        for more information about the terms used in the database.
                    </p>
                    <p className="ending-paragraph">
                        Please review the Musical Works Database
                        <a href="https://www.themlc.com/musicalworksdatabasetermsuse" target="_blank" rel="noreferrer">
                            {' '}
                            Terms of Use
                        </a>
                    </p>
                    <div className="public-search-container">
                        <TabsWrapperComponent tabs={publicSearchTabs} defaultTab={publicSearchTabs[0]} />
                    </div>
                    <ModalPortal isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
                        <Popup showClose={false} onClose={() => setIsPopupOpen(false)}>
                            <PublicSearchPopup closePopup={() => setIsPopupOpen(false)} />
                        </Popup>
                    </ModalPortal>
                </div>
            </main>
        </>
    )
}

export default PublicSearchScene
